import React, { useState } from "react";
import styles from "./Canvas.css";
import { setBgAction } from "actions/setBgAction";
import { setBackgroundColorAction } from "actions/setBackgroundColorAction";
import { setElementAction } from "actions/setElementAction";
import { deleteSVGElementAction } from "actions/deleteSVGElementAction";
import { setSelectedElementAction } from "actions/setSelectedElementAction";
import { setSelectedElementsAction } from "actions/setSelectedElementsAction";
import { setDrawSVGAction } from "actions/setDrawSVGAction";
import { setSVGGroupAction } from "actions/setSVGGroupAction";
import { setDesignAction } from "actions/setDesignAction";
import { setUserAction } from "actions/setUserAction";
import {ExportDrawer} from "components/ExportDrawer/ExportDrawer";
import { connect } from "react-redux";
import SVG from "svg.js";
import "svg.draggable.js";
import "svg.select.js";
import "svg.resize.js";
import { loadFull } from "tsparticles";
import { withRouter } from "react-router-dom";
import * as blobs2 from "blobs/v2";
import gradientData from "../Gradients/gradient_collection_resource.json";
import radialGradientData from "../Gradients/radial_gradients.json";
import axios from "axios";
import queryString from "query-string";

import Particles from "react-tsparticles";

import firebase from "firebase";
import Triangulr from "triangulr";
import Canvg from 'canvg';
import { DarkMode, Button, LightMode, useColorMode, } from "@chakra-ui/core";
import { graphqlOperation } from 'aws-amplify';
import { getTodo, getTemplate } from 'graphql/queries';
import {API} from "aws-amplify";
import { Event } from "../Tracking";

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = (dispatch) => ({
  setBgAction: (payload) => dispatch(setBgAction(payload)),
  setElementAction: (payload) => dispatch(setElementAction(payload)),
  setBackgroundColorAction: (payload) =>
    dispatch(setBackgroundColorAction(payload)),
  deleteSVGElementAction: () => dispatch(deleteSVGElementAction),
  setSelectedElementAction: (payload) =>
    dispatch(setSelectedElementAction(payload)),
  setSelectedElementsAction: (payload) =>
    dispatch(setSelectedElementsAction(payload)),
  setDrawSVGAction: (payload) => dispatch(setDrawSVGAction(payload)),
  setSVGGroupAction: (payload) => dispatch(setSVGGroupAction(payload)),
  setDesignAction: (payload) => dispatch(setDesignAction(payload)),
  setUserAction: (payload) => dispatch(setUserAction(payload)),
});

class Canvas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      svgHeight: 1100,
      svgWidth: 1200,
      width: 60,
      container: {},
      gradient: null,
      draw: null,
      user: null,
      gradient_color: "#897",
      design: {
        designType: "animated",
        title: "Design1",
      },
      svg_overlay_particle_options: 
        {"autoPlay":true,"background":{"color":{"value":"#567698"},"image":"linear-gradient(90deg, #5757D9 0%, #21D9F7 100%)","position":"","repeat":"","size":"","opacity":1},"backgroundMask":{"composite":"destination-out","cover":{"color":{"value":"#fff"},"opacity":1},"enable":false},"backgroundMode":{"enable":false,"zIndex":-1},"detectRetina":true, "infection":{"cure":false,"delay":0,"enable":false,"infections":0,"stages":[]},"interactivity":{"detectsOn":"canvas","events":{"onClick":{"enable":true,"mode":"repulse"},"onDiv":{"selectors":[],"enable":false,"mode":[],"type":"circle"},"onHover":{"enable":true,"mode":"bubble","parallax":{"enable":false,"force":2,"smooth":10}},"resize":true},"modes":{"attract":{"distance":200,"duration":0.4,"speed":1},"bounce":{"distance":200},"bubble":{"distance":250,"duration":2,"opacity":0,"size":0},"connect":{"distance":80,"links":{"opacity":0.5},"radius":60},"grab":{"distance":400,"links":{"blink":false,"consent":false,"opacity":1}},"light":{"area":{"gradient":{"start":{"value":"#ffffff"},"stop":{"value":"#000000"}},"radius":1000},"shadow":{"color":{"value":"#000000"},"length":2000}},"push":{"quantity":4},"remove":{"quantity":2},"repulse":{"distance":400,"duration":0.4,"speed":1},"slow":{"factor":3,"radius":200},"trail":{"delay":1,"quantity":1}}},"manualParticles":[],"motion":{"disable":false,"reduce":{"factor":4,"value":false}},"particles":{"bounce":{"horizontal":{"random":{"enable":false,"minimumValue":0.1},"value":1},"vertical":{"random":{"enable":false,"minimumValue":0.1},"value":1}},"collisions":{"bounce":{"horizontal":{"random":{"enable":false,"minimumValue":0.1},"value":1},"vertical":{"random":{"enable":false,"minimumValue":0.1},"value":1}},"enable":false,"mode":"bounce"},"color":{"value":"#ffffff","animation":{"enable":false,"speed":1,"sync":true}},"life":{"count":0,"delay":{"random":{"enable":false,"minimumValue":0},"value":0,"sync":false},"duration":{"random":{"enable":false,"minimumValue":0.0001},"value":0,"sync":false}},"links":{"blink":false,"color":{"value":"#ffffff"},"consent":false,"distance":150,"enable":false,"frequency":1,"opacity":0.4,"shadow":{"blur":5,"color":{"value":"#00ff00"},"enable":false},"triangles":{"enable":false,"frequency":1},"width":1,"warp":false},"move":{"angle":{"offset":45,"value":90},"attract":{"enable":false,"rotate":{"x":600,"y":600}},"direction":"none","distance":0,"enable":true,"gravity":{"acceleration":9.81,"enable":false,"maxSpeed":50},"noise":{"delay":{"random":{"enable":false,"minimumValue":0},"value":0},"enable":false},"outModes":{"default":"out","bottom":"out","left":"out","right":"out","top":"out"},"random":true,"size":false,"speed":1,"straight":false,"trail":{"enable":false,"length":10,"fillColor":{"value":"#000000"}},"vibrate":false,"warp":false},"number":{"density":{"enable":true,"area":800,"factor":1000},"limit":0,"value":160},"opacity":{"random":{"enable":true,"minimumValue":1},"value":1,"animation":{"enable":true,"minimumValue":0,"speed":1,"sync":false}},"reduceDuplicates":false,"rotate":{"random":{"enable":false,"minimumValue":0},"value":0,"animation":{"enable":false,"speed":0,"sync":false},"direction":"clockwise","path":false},"shadow":{"blur":0,"color":{"value":"#000000"},"enable":false,"offset":{"x":0,"y":0}},"shape":{"options":{"polygon":{"nb_sides":5},"star":{"nb_sides":5},"image":{"src":"https://cdn.matteobruni.it/images/particles/github.svg","width":100,"height":100},"images":{"src":"https://cdn.matteobruni.it/images/particles/github.svg","width":100,"height":100}},"type":"circle"},"size":{"random":{"enable":true,"minimumValue":1},"value":3,"animation":{"destroy":"none","enable":false,"minimumValue":0.3,"speed":4,"startValue":"max","sync":false}},"stroke":{"width":0,"color":{"value":"#000000","animation":{"enable":false,"speed":1,"sync":true}}},"twinkle":{"lines":{"enable":false,"frequency":0.05,"opacity":1},"particles":{"enable":false,"frequency":0.05,"opacity":1}}},"pauseOnBlur":true,"pauseOnOutsideViewport":false,"themes":[]}
      ,
      sample_animated_triangles_design : {
        designType: "animated_triangles", 
        title: "Design1",
      },
      sample_triangles_design : {
        designType: "triangles", 
        title: "Design1",
        body: {
          alteredColor: "red",
          codes: ["10", "92"],
          randomColorNum: 32,
        }
      },
      sample_gradient_waves_design : {
        designType: "svgWaves", 
        title: "Design1",
        body: {
          gradient: {
            color1: "hsla(217, 100%, 50%, 1)" ,
            color2: "hsla(286, 100%, 69%, 1)",
            deg: "90",
          }
        }
      },
      sample_gradient_design : {
        designType: "gradient",
        body: {
          color1: "hsla(217, 100%, 50%, 1)",
          color2: "hsla(186, 100%, 69%, 1)",
          deg: "180"
        },
        title: "Design1",
      },
      sample_radial_gradient_design : {
        designType: "radialGradient",
        body: {
          color1: "rgb(225, 5, 152)",
          color2: "rgb(26, 1, 117)",
          color3: "hsla(179, 91%, 45%, 1)",
          color4: "rgb(189, 5, 245)",
        },
        title: "Design1",
      },
      isSVGDesign: false,
      isAnimatedDesign: false,
      isGradientDesign: true,
      selectedElement: null,
      selectedElements: [],
      copiedElement: null,
      gradients: [],
      options: [],
      particlesOptions: {},
      sample_particles_options: {
        "background": {
          "color": {
            "value": "#0d47a1"
          },
          "image":"linear-gradient(180deg, hsla(280, 84%, 41%, 1) 0%, hsla(218, 97%, 56%, 1) 100%)",

        },
        "fullScreen": {
          "zIndex": 1
        },
        "interactivity": {
          "events": {
            "onClick": {
              "mode": "push"
            },
            "onHover": {
              "mode": "repulse"
            }
          },
          "modes": {
            "attract": {
              "distance": 200,
              "duration": 0.4,
              "easing": "ease-out-quad",
              "factor": 1,
              "maxSpeed": 50,
              "speed": 1
            },
            "bounce": {
              "distance": 200
            },
            "bubble": {
              "distance": 400,
              "duration": 2,
              "mix": false,
              "opacity": 0.8,
              "size": 40,
              "divs": {
                "distance": 200,
                "duration": 0.4,
                "mix": false,
                "selectors": []
              }
            },

            "grab": {
              "distance": 400,
              "links": {
                "blink": false,
                "consent": false,
                "opacity": 1
              }
            },
            "push": {
              "default": true,
              "groups": [],
              "quantity": 4
            },
            "remove": {
              "quantity": 2
            },
            "repulse": {
              "distance": 200,
              "duration": 0.4,
              "factor": 100,
              "speed": 1,
              "maxSpeed": 50,
              "easing": "ease-out-quad",
              "divs": {
                "distance": 200,
                "duration": 0.4,
                "factor": 100,
                "speed": 1,
                "maxSpeed": 50,
                "easing": "ease-out-quad",
                "selectors": []
              }
            },
            "trail": {
              "pauseOnStop": false,
              "quantity": 1
            },
            "light": {
              "area": {
                "gradient": {
                  "start": {
                    "value": "#ffffff"
                  },
                  "stop": {
                    "value": "#000000"
                  }
                },
                "radius": 1000
              },
              "shadow": {
                "color": {
                  "value": "#000000"
                },
                "length": 2000
              }
            }
          }
        },
        "particles": {
          "color": {
            "value": "#ffffff"
          },
          "move": {
            "attract": {
              "rotate": {
                "x": 600,
                "y": 1200
              }
            },
            "enable": true,
            "outModes": {
              "default": "destroy",
              "bottom": "destroy",
              "left": "destroy",
              "right": "destroy",
              "top": "destroy"
            },
            "speed": 5
          },
          "number": {
            "density": {
              "enable": true
            },
            "value": 0
          },
          "opacity": {
            "animation": {
              "speed": 3,
              "minimumValue": 0.1
            }
          },

          "life": {
            "count": 0,

            "duration": {
              "random": {
                "enable": false,
                "minimumValue": 0.0001
              },
              "value": 0,
              "sync": false
            }
          },
          "roll": {
            "darken": {
              "enable": false,
              "value": 0
            },
            "enable": false,
            "enlighten": {
              "enable": false,
              "value": 0
            },
            "mode": "vertical",
            "speed": 25
          },
          "tilt": {
            "random": {
              "enable": false,
              "minimumValue": 0
            },
            "value": 0,
            "animation": {
              "enable": false,
              "speed": 0,
              "decay": 0,
              "sync": false
            },
            "direction": "clockwise",
            "enable": false
          },
          "twinkle": {
            "lines": {
              "enable": false,
              "frequency": 0.05,
              "opacity": 1
            },
            "particles": {
              "enable": false,
              "frequency": 0.05,
              "opacity": 1
            }
          },
          "wobble": {
            "distance": 5,
            "enable": false,
            "speed": {
              "angle": 50,
              "move": 10
            }
          },
          "orbit": {
            "animation": {
              "count": 0,
              "enable": false,
              "speed": 1,
              "decay": 0,
              "sync": false
            },
            "enable": false,
            "opacity": 1,
            "rotation": {
              "random": {
                "enable": false,
                "minimumValue": 0
              },
              "value": 45
            },
            "width": 1
          },
          "links": {
            "blink": false,
            "color": {
              "value": "#ffffff"
            },
            "consent": false,
            "distance": 150,
            "enable": false,
            "frequency": 1,
            "opacity": 0.4,
            "shadow": {
              "blur": 5,
              "color": {
                "value": "#000"
              },
              "enable": false
            },
            "triangles": {
              "enable": false,
              "frequency": 1
            },
            "width": 1,
            "warp": false
          },
          "repulse": {
            "random": {
              "enable": false,
              "minimumValue": 0
            },
            "value": 0,
            "enabled": false,
            "distance": 1,
            "duration": 1,
            "factor": 1,
            "speed": 1
          }
        },
        "emitters": {
          "autoPlay": true,
          "fill": true,
          "life": {
            "wait": false
          },
          "rate": {
            "quantity": 2,
          },
          "shape": "square",
          "startCount": 0,
          "size": {
            "mode": "percent",
            "height": 0,
            "width": 100
          },
          "direction": "top",
          "position": {
            "x": 50,
            "y": 100
          }
        }
      },
      mask_options: {
        "background": {"color" : {"value":"#567698"}},
        "backgroundMask": {
          "cover": {
            "color": {
              "value": {
                "r": 255,
                "g": 255,
                "b": 255
              }
            }
          },
          "enable": true
        },
        "interactivity": {
          "events": {
            "onClick": {
              "enable": true,
              "mode": "push"
            },
            "onHover": {
              "enable": true,
              "mode": "bubble",
              "parallax": {
                "force": 60
              }
            }
          },
          "modes": {
            "bubble": {
              "distance": 400,
              "duration": 2,
              "opacity": 1,
              "size": 100
            },
            "grab": {
              "distance": 400
            }
          }
        },
        "particles": {
          "color": {
            "value": "#ffffff"
          },
          "links": {
            "color": {
              "value": "#ffffff"
            },
            "distance": 150,
            "enable": true
          },
          "move": {
            "attract": {
              "rotate": {
                "x": 600,
                "y": 1200
              }
            },
            "enable": true,
            "outModes": {
              "bottom": "out",
              "left": "out",
              "right": "out",
              "top": "out"
            }
          },
          "number": {
            "density": {
              "enable": true
            },
            "value": 80
          },
          "opacity": {
            "animation": {
              "minimumValue": 0.1,
              "speed": 1
            }
          },
          "shape": {
            "options": {
              "polygon": {
                "nb_sides": 5
              },
              "star": {
                "nb_sides": 5
              },
              "image": {
                "src": "https://cdn.matteobruni.it/images/particles/github.svg",
                "width": 100,
                "height": 100
              },
              "images": {
                "src": "https://cdn.matteobruni.it/images/particles/github.svg",
                "width": 100,
                "height": 100
              }
            }
          },
          "size": {
            "random": {
              "enable": true
            },
            "value": 30,
            "animation": {
              "minimumValue": 0.1,
              "speed": 40
            }
          },
          "stroke": {
            "color": {
              "value": "#000000",
              "animation": {
                "enable": false,
                "speed": 1,
                "sync": true
              }
            }
          }
        }
      },
      mask_options: {
        "background": {"color" : {"value":"#567698"}},
        "backgroundMask": {
          "cover": {
            "color": {
              "value": {
                "r": 255,
                "g": 255,
                "b": 255
              }
            }
          },
          "enable": true
        },
        "interactivity": {
          "events": {
            "onClick": {
              "enable": true,
              "mode": "push"
            },
            "onHover": {
              "enable": true,
              "mode": "bubble",
              "parallax": {
                "force": 60
              }
            }
          },
          "modes": {
            "bubble": {
              "distance": 400,
              "duration": 2,
              "opacity": 1,
              "size": 100
            },
            "grab": {
              "distance": 400
            }
          }
        },
        "particles": {
          "color": {
            "value": "#ffffff"
          },
          "links": {
            "color": {
              "value": "#ffffff"
            },
            "distance": 150,
            "enable": true
          },
          "move": {
            "attract": {
              "rotate": {
                "x": 600,
                "y": 1200
              }
            },
            "enable": true,
            "outModes": {
              "bottom": "out",
              "left": "out",
              "right": "out",
              "top": "out"
            }
          },
          "number": {
            "density": {
              "enable": true
            },
            "value": 80
          },
          "opacity": {
            "animation": {
              "minimumValue": 0.1,
              "speed": 1
            }
          },
          "shape": {
            "options": {
              "polygon": {
                "nb_sides": 5
              },
              "star": {
                "nb_sides": 5
              },
              "image": {
                "src": "https://cdn.matteobruni.it/images/particles/github.svg",
                "width": 100,
                "height": 100
              },
              "images": {
                "src": "https://cdn.matteobruni.it/images/particles/github.svg",
                "width": 100,
                "height": 100
              }
            }
          },
          "size": {
            "random": {
              "enable": true
            },
            "value": 30,
            "animation": {
              "minimumValue": 0.1,
              "speed": 40
            }
          },
          "stroke": {
            "color": {
              "value": "#000000",
              "animation": {
                "enable": false,
                "speed": 1,
                "sync": true
              }
            }
          }
        }
      },
      sample_svg_overlay_design : {
        designType: "svg_overlay", 
        title: "Design1",
        body:  {svg_str: '<defs id="SvgjsDefs1002"></defs><rect id="SvgjsRect1011" width="120" height="120" x="462" y="483.00001525878906" fill="#ff0088" transform="matrix(1,0,0,1,0,0)"></rect>',
      particle_options: {"autoPlay":true,"background":{"color":{"value":"#567698"},"image":"linear-gradient(90deg, #5757D9 0%, #21D9F7 100%)","position":"","repeat":"","size":"","opacity":1},"backgroundMask":{"composite":"destination-out","cover":{"color":{"value":"#fff"},"opacity":1},"enable":false},"backgroundMode":{"enable":false,"zIndex":-1},"detectRetina":true, "infection":{"cure":false,"delay":0,"enable":false,"infections":0,"stages":[]},"interactivity":{"detectsOn":"canvas","events":{"onClick":{"enable":true,"mode":"repulse"},"onDiv":{"selectors":[],"enable":false,"mode":[],"type":"circle"},"onHover":{"enable":true,"mode":"bubble","parallax":{"enable":false,"force":2,"smooth":10}},"resize":true},"modes":{"attract":{"distance":200,"duration":0.4,"speed":1},"bounce":{"distance":200},"bubble":{"distance":250,"duration":2,"opacity":0,"size":0},"connect":{"distance":80,"links":{"opacity":0.5},"radius":60},"grab":{"distance":400,"links":{"blink":false,"consent":false,"opacity":1}},"light":{"area":{"gradient":{"start":{"value":"#ffffff"},"stop":{"value":"#000000"}},"radius":1000},"shadow":{"color":{"value":"#000000"},"length":2000}},"push":{"quantity":4},"remove":{"quantity":2},"repulse":{"distance":400,"duration":0.4,"speed":1},"slow":{"factor":3,"radius":200},"trail":{"delay":1,"quantity":1}}},"manualParticles":[],"motion":{"disable":false,"reduce":{"factor":4,"value":false}},"particles":{"bounce":{"horizontal":{"random":{"enable":false,"minimumValue":0.1},"value":1},"vertical":{"random":{"enable":false,"minimumValue":0.1},"value":1}},"collisions":{"bounce":{"horizontal":{"random":{"enable":false,"minimumValue":0.1},"value":1},"vertical":{"random":{"enable":false,"minimumValue":0.1},"value":1}},"enable":false,"mode":"bounce"},"color":{"value":"#ffffff","animation":{"enable":false,"speed":1,"sync":true}},"life":{"count":0,"delay":{"random":{"enable":false,"minimumValue":0},"value":0,"sync":false},"duration":{"random":{"enable":false,"minimumValue":0.0001},"value":0,"sync":false}},"links":{"blink":false,"color":{"value":"#ffffff"},"consent":false,"distance":150,"enable":false,"frequency":1,"opacity":0.4,"shadow":{"blur":5,"color":{"value":"#00ff00"},"enable":false},"triangles":{"enable":false,"frequency":1},"width":1,"warp":false},"move":{"angle":{"offset":45,"value":90},"attract":{"enable":false,"rotate":{"x":600,"y":600}},"direction":"none","distance":0,"enable":true,"gravity":{"acceleration":9.81,"enable":false,"maxSpeed":50},"noise":{"delay":{"random":{"enable":false,"minimumValue":0},"value":0},"enable":false},"outModes":{"default":"out","bottom":"out","left":"out","right":"out","top":"out"},"random":true,"size":false,"speed":1,"straight":false,"trail":{"enable":false,"length":10,"fillColor":{"value":"#000000"}},"vibrate":false,"warp":false},"number":{"density":{"enable":true,"area":800,"factor":1000},"limit":0,"value":160},"opacity":{"random":{"enable":true,"minimumValue":1},"value":1,"animation":{"enable":true,"minimumValue":0,"speed":1,"sync":false}},"reduceDuplicates":false,"rotate":{"random":{"enable":false,"minimumValue":0},"value":0,"animation":{"enable":false,"speed":0,"sync":false},"direction":"clockwise","path":false},"shadow":{"blur":0,"color":{"value":"#000000"},"enable":false,"offset":{"x":0,"y":0}},"shape":{"options":{"polygon":{"nb_sides":5},"star":{"nb_sides":5},"image":{"src":"https://cdn.matteobruni.it/images/particles/github.svg","width":100,"height":100},"images":{"src":"https://cdn.matteobruni.it/images/particles/github.svg","width":100,"height":100}},"type":"circle"},"size":{"random":{"enable":true,"minimumValue":1},"value":3,"animation":{"destroy":"none","enable":false,"minimumValue":0.3,"speed":4,"startValue":"max","sync":false}},"stroke":{"width":0,"color":{"value":"#000000","animation":{"enable":false,"speed":1,"sync":true}}},"twinkle":{"lines":{"enable":false,"frequency":0.05,"opacity":1},"particles":{"enable":false,"frequency":0.05,"opacity":1}}},"pauseOnBlur":true,"pauseOnOutsideViewport":false,"themes":[]}
      },        
      },
      group: null,
      templates: [],
      template_svg:
        '<defs id="SvgjsDefs1002"></defs><rect id="SvgjsRect1011" width="120" height="120" x="462" y="483.00001525878906" fill="#ff0088" transform="matrix(1,0,0,1,0,0)"></rect>',
    };
    this.gradientRef = React.createRef();
  }

  updateSVGBackgroundTemplate(template) {
    this.displaySVGBackground();
  }

  updateAnimatedBackgroundFromOnlineDesign(template) {
    // hide SVG background
    let particles_options = JSON.parse(template.body);
    // ensure background mode is enabled

    let design = this.state.design;
    design.body = particles_options;
    if (design.designType != "svgWavesAnimated") {
       design.designType = template.designType;
    }
    this.setState({ design: design, particlesOptions: particles_options });
    
    this.props.setDesignAction(design);

  }


  updateAnimatedBackgroundForSVGOverlay(particles_options) {

    let design = this.state.design;
    let design_body = JSON.parse(design.body);

    design.body = design_body;
    design.body.particle_options = particles_options;

    this.setState({ design: design, particlesOptions: particles_options });
    
    this.props.setDesignAction(design);
  }

  setAnimatedBackground(design) {
    let new_design = design;
    new_design.designType = "animated";
    new_design.body = design.body;
    delete new_design.container;
    let new_container = {};

    this.setState({design: new_design});
    this.props.setDesignAction(new_design);
    
  }

  async fetchAndInitTemplate(template_id) {
    if (template_id) {
      // let response = await API.graphql(graphqlOperation(getTemplate, {id: template_id,}));
      const response = await API.graphql({
        query: getTemplate,
        variables: {id: template_id},
        authMode: 'API_KEY'
      });


      let template = response.data.getTemplate;
      
      if (template.designType == "svg") {
        this.initSVG(template, "svg_illustration", "existing_design");
      }
      else if (template.designType == "svg_overlay") {
        this.initSVGOverlay(template)
      }
      else if (template.designType == "gradient") {
        this.initGradient(template);
      
      }      
      else if (template.designType == "radialGradient") {
        this.initRadialGradient(template);
      
      }  
      else if (template.designType == "animated") {
        this.updateAnimatedBackgroundFromOnlineDesign(template);
      }
      else if (template.designType == "animated_gradient") {
        this.initGradient(template);
      }
      else if (template.designType == "triangles") {
        this.initTriangleDesign(template);
      } 
    
    }
      
  }

  async getDesign(design_id) {
    if (design_id) {
      // we're updating the design
      let response = await API.graphql(graphqlOperation(getTodo, {id: design_id}))

          let design = response.data.getTodo;

          if (design.designType == "svg") {
            this.initSVG(design, "svg_illustration", "existing_design");
          }
          else if (design.designType == "svg_overlay") {
            this.initSVGOverlay(design)
          }
          else if (design.designType == "gradient") {
            this.initGradient(design);
          
          } 
          else if (design.designType == "radialGradient") {
            this.initRadialGradient(design);
          
          } 
          else if (design.designType == "triangles") {
            this.initTriangleDesign(design);
          } 
          else if (design.designType == "animated_gradient") {
            this.initGradient(design);
          }
          else if (design.designType == "animated") {
            this.updateAnimatedBackgroundFromOnlineDesign(design);
          }
          else if (design.designType == "svgWaves") {
            let design_body = JSON.parse(design.body);
            design.body = design_body;
            this.initSVGWaves(design);
          }
          else if (design.designType == "svgWavesAnimated") {
            
            this.drawSVGWaves();
            this.updateAnimatedBackgroundFromOnlineDesign(design);

          }
        
    }
  }


  displaySVGBackground() {
    this.setState({ isSVGDesign: true});
  }

  initTriangleDesign(design) {
    let triangles_body = JSON.parse(design.body);

    design.body = triangles_body;

    this.setState({ design: design});
    this.props.setDesignAction(design);

    this.drawTrianglesDesign(design.body)
  }

  initRadialGradient(gradient_design) {
    let design = this.state.design;
    let gradient_body = JSON.parse(gradient_design.body);
    this.gradientRef.current.style.background = `linear-gradient(45deg, ${gradient_body.color1} 0%, hsla(352, 96%, 45%, 0) 70%),
    linear-gradient(135deg, ${gradient_body.color2} 10%, hsla(253, 95%, 42%, 0) 80%),
    linear-gradient(225deg, ${gradient_body.color3} 10%, hsla(179, 91%, 45%, 0) 80%),
    linear-gradient(315deg, ${gradient_body.color4} 100%, hsla(119, 96%, 49%, 0) 70%)`;

    design.body = gradient_body;
    design.createdAt = gradient_design.createdAt;
    design.designType = "radialGradient"

    this.setState({ design: design});
    this.props.setDesignAction(design);
  }

  initGradient(gradient_design) {
    let design = this.state.design;
    let gradient_body = JSON.parse(gradient_design.body);
    this.gradientRef.current.style.background = `linear-gradient(${gradient_body.deg}deg, ${gradient_body.color1} 0%, ${gradient_body.color2} 100%)`;

    if (gradient_design.designType == "animated_gradient") {
      this.gradientRef.current.style.backgroundSize = "400% 400%";
      this.gradientRef.current.style.animation = "gradient 25s ease infinite";
    }

    design.body = gradient_body;
    design.createdAt = gradient_design.createdAt;
    design.designType = "gradient"

    this.setState({ design: design});
    this.props.setDesignAction(design);
  }

  initSVGOverlay(design) {

    this.setState({design: design});
    this.initSVG(this.state.design, "svg_overlay_illustration", "existing_design");
    let design_body = JSON.parse(design.body);
    let particles_options = design_body.particle_options;
    this.updateAnimatedBackgroundForSVGOverlay(particles_options);
  }

  initSVG(design, svg_container_id, design_status) {

    let svg_str_obj = JSON.parse(design.body);
    let svg_str = svg_str_obj.svg_str;

    this.state.gradients = gradientData.gradients;

    // document.addEventListener("keydown", this.onKeyPressed.bind(this));

    this.state.draw = SVG(svg_container_id).size("100%", "100%");

    this.props.setSelectedElementsAction(this.state.selectedElements);
    this.props.setDrawSVGAction(this.state.draw);

    this.state.group = this.state.draw.group("main");
    this.props.setSVGGroupAction(this.state.group);

    this.state.draw.viewbox(0, 0, 600, 150)

    let svg_elem = this.state.group.svg(svg_str);
    var app = this;

    let children = svg_elem.children();
    for (let i = 0; i < children.length; i++) {
      let child = children[i];

      child.draggable();
      app.state.group.add(child);
    }


    // this.state.gradient = this.state.draw.gradient('linear', (add) => {
    //   add.at(0, this.props.bgColor.color1);
    //   add.at(1, this.props.bgColor.color2);
    // });

    if (design_status == "new") {
      this.state.group
      .path(
        "M0,256L48,229.3C96,203,192,149,288,154.7C384,160,480,224,576,218.7C672,213,768,139,864,128C960,117,1056,171,1152,197.3C1248,224,1344,224,1392,224L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
      )
      .fill("white")
      .opacity(1.0)
      .draggable();
    }


    // var pattern = this.state.draw.pattern(20, 20, function(add) {
    //   add.rect(20,20).fill('#f06')
    //   add.rect(10,10)
    //    add.rect(10,10).move(10,10)
    // });

    // let path = this.state.draw.path(blob_path)
    // .fill(pattern).opacity(1.0).draggable();

    // children = children.filter(item => item.type == "defs")[0];

    // console.log("children", children);
    // this.state.draw.put(children);

    var app = this;
    // // draw.each(block, deep)

    // this.state.draw.each(function(i, children) {
    //   console.log("draw ", this);
    //   if (this.type == "svg") {
    //     this.each(function(i, children) {
    //       console.log("inner child", this);
    //       app.state.draw.add(this);
    //     }, true);
    //   }
    //   // let clone = this.clone();
    //   // clone.draggable();
    //   // clone.addTo(app.state.draw);
    // }, false);

    this.addOnClickListeners();
    this.setState({ isSVGDesign: true, design: design});
    this.props.setDesignAction(design);
  }

  componentDidMount() {
    this.initCanvas();
  }

  initCanvas() {
    const value = queryString.parse(this.props.location.search);
    const design_id = value.design;
    const template_id = value.template;
    const design_type_id = value.designType;

    if (design_id) {
      // design in redux
       if (this.props.design != null) {
        //  this.setAnimatedBackground(this.state.particlesOptions);
        this.getDesign(design_id);

       }
       else {
         // design not stored in redux, so fetch design
        this.getDesign(design_id);

       }
    } else if (template_id) {
      // check if it's a template, if not, then present
      this.fetchAndInitTemplate(template_id);
      } 
      else if (design_type_id) {
        let new_design_str = `Design type chosen is ${design_type_id}`;
        Event("DESIGN_TYPE", new_design_str, "DESIGN_TYPE");

        switch(design_type_id) {
          case "triangle":
            this.startWithTrianglesBackground();
            break;
          case "animatedParticles":
            let particles = this.state.sample_particles_options;
            let particles_str = JSON.stringify(particles);
            let template = {body: particles_str, "title": "Design 1", "designType": "animated"}
            
            this.updateAnimatedBackgroundFromOnlineDesign(template)
            break;
          case "gradient":
            this.startWithGradientBackground();
            break;
          case "animatedGradient":
            this.startWithAnimatedGradientBackground();
            break;
          case "svgOverlay":
            this.startWithSVGOverlayBackground();
            break;
          case "radialGradient":
              this.startWithRadialGradientBackground();
              break;
          case "svgWavesAnimated":
            // this.startWithSVGWavesBackground(true);
        
            let design = this.state.design;    
              design.designType = "svgWavesAnimated";
            
            this.setState({design: design});
            this.props.setDesignAction(design);
        
            this.drawSVGWaves();

            this.fetchAndInitTemplate("9184521d-5d7f-4558-9c5e-89f4761dbee3")
            break;
          case "svgWaves":
            this.startWithSVGWavesBackground(false);
              break;
            
        }
      }
      else {
        // new design, so initialize with a template svg string
        this.startWithParticlesBackground();
        //this.startWithTrianglesBackground();
        // this.startWithAnimatedTrianglesBackground();
        //this.startWithGradientBackground();
        //this.startWithSVGOverlayBackground();
        //this.startWithRadialGradientBackground();
    }
  }

  startWithSVGOverlayBackground() {
    let design = this.state.sample_svg_overlay_design;
    let particles_options = this.state.sample_svg_overlay_design.body.particle_options;

    let body_str = JSON.stringify(design.body);
    design.body = body_str;
    
    this.setState({design: design});
    this.props.setDesignAction(this.state.design);
  
    this.initSVG(this.state.design, "svg_overlay_illustration", "new");

    // this.updateAnimatedBackgroundFromOnlineDesign(template);
    this.updateAnimatedBackgroundForSVGOverlay(particles_options);
  }

  startWithRadialGradientBackground() {
    const qs = queryString.parse(this.props.location.search);
    const gradient_name = qs.gradientName;

    if (gradient_name) {
      let gradient = radialGradientData.gradients.filter(gradient => gradient.name == gradient_name)[0];
      let design =     {
        designType: "radialGradient",
        title: "Radial Gradient",
      };
      if (gradient) {
        design.body = gradient;
        // this.gradientRef.current.style.background = `linear-gradient(${gradient.deg}deg, ${gradient.color1} 0%, ${gradient.color2} 100%)`;

        this.gradientRef.current.style.background = `linear-gradient(45deg, ${gradient.color1} 0%, hsla(352, 96%, 45%, 0) 70%),
        linear-gradient(135deg, ${gradient.color2} 10%, hsla(253, 95%, 42%, 0) 80%),
        linear-gradient(225deg, ${gradient.color3} 10%, hsla(179, 91%, 45%, 0) 80%),
        linear-gradient(315deg, ${gradient.color4} 100%, hsla(119, 96%, 49%, 0) 70%)`;

        this.setState({design: design});
  
        this.props.setDesignAction(design);
      }

    }
    // no gradient name in URL
    else {
      let design = this.state.sample_radial_gradient_design;
      this.gradientRef.current.style.background = `linear-gradient(45deg, ${design.body.color1} 0%, hsla(352, 96%, 45%, 0) 70%),
      linear-gradient(135deg, ${design.body.color2} 10%, hsla(253, 95%, 42%, 0) 80%),
      linear-gradient(225deg, ${design.body.color3} 10%, hsla(179, 91%, 45%, 0) 80%),
      linear-gradient(315deg, ${design.body.color4} 100%, hsla(119, 96%, 49%, 0) 70%)`;
      this.setState({design: design});

      this.props.setDesignAction(design);
    }

  }

  startWithGradientBackground() {
    const qs = queryString.parse(this.props.location.search);
    const gradient_name = qs.gradientName;

    if (gradient_name) {
      let gradient = gradientData.gradients.filter(gradient => gradient.name == gradient_name)[0];
      let design =     {
        designType: "gradient",
        title: "Design2",
      };
      if (gradient) {
        design.body = gradient;
        this.gradientRef.current.style.background = `linear-gradient(${gradient.deg}deg, ${gradient.color1} 0%, ${gradient.color2} 100%)`;
        this.setState({design: design});
  
        this.props.setDesignAction(design);
      }

    }
    // no gradient name in URL
    else {
      let design = this.state.sample_gradient_design;
      this.gradientRef.current.style.background = `linear-gradient(${design.body.deg}deg, ${design.body.color1} 0%, ${design.body.color2} 100%)`;
      this.setState({design: design});

      this.props.setDesignAction(design);
    }

  }
  
  async particlesInit (main)  {

    // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
     await loadFull(main);
  };

  startWithAnimatedGradientBackground() {
    let design = this.state.sample_gradient_design;
    design.designType = "animated_gradient";
    this.setState({design: design});
    this.gradientRef.current.style.background = `linear-gradient(${design.deg}, ${design.color1} 0%, ${design.color2} 100%)`;
    this.gradientRef.current.style.backgroundSize = "400% 400%";
    this.gradientRef.current.style.animation = "gradient 25s ease infinite";
    
    this.props.setDesignAction(design);

  }

  startWithAnimatedTrianglesBackground() {

    // var renderer =  new FSS.CanvasRenderer();
    
    // var container = document.getElementById('animated_triangles');
    // container.appendChild(renderer.element);
    
    // var scene = new fss.Scene();
 
    // var geometry = new fss.Plane(200, 100, 4, 2);
    // var material = new fss.Material('#444444', '#FFFFFF');
    // var mesh = new fss.Mesh(geometry, material);
    // scene.add(mesh);
    
    // var light = new fss.Light('#FF0000', '#0000FF');
    // scene.add(light);
    
    // renderer.render(scene);

    this.setState({design: this.state.sample_animated_triangles_design});
    this.props.setDesignAction(this.state.design);

  }

  startWithTrianglesBackground() {
    var app = this;
    var colorGenerator = function (path) {
      var random = 52;
      var ratio = (path.x * path.y) / (path.cols * path.lines);
      var code = Math.floor(255 - (ratio * (255-random)) - Math.random()*random).toString(16);
      return '#'+code+code+code;
    };

    var headerMapColorRender = function (path) {
		  var random = 32;
		  var ratio = (path.x + path.y) / (path.cols + path.lines);
		  var code = Math.floor(255 - (ratio * (255-random)) - Math.random()*random).toString(16);
      //1092
      // 96E8
      // ACEF
      // 1CEF
      // 51AF
      // 518A
      return '#' + code + '1092';
		};

    // var headerMapColorRender = function (path) {
    //   console.log("path: ", path);
    //   let modulus_res = path.x % 3;
    
		//   var random = 12;
		//   var ratio = (path.x + path.y) / (path.cols + path.lines);
    //   var code = Math.floor(255 - (ratio * (255-random)) - Math.random()*random).toString(16);
    //   let code_str = '#' + code + "11" + code;

    //   let colors = ["#00f000", "#fafafa", "#457811", "#897867"];
    //   if (modulus_res == 0) {
    //     return colors[0];
    //   }
    //   else if (modulus_res == 1) {
    //     return colors[1];
    //   }
    //   else if (modulus_res == 2) {
    //     return colors[2];
    //   }
    //   else {
    //     return colors[3]
    //   }
      
      
    // };
    
    var svg = new Triangulr (window.innerWidth, window.innerHeight * 1.7, 100, 50, headerMapColorRender);
    document.getElementById('triangles').appendChild(svg);


    //
    
    let svg_str = svg.innerHTML;


    let draw = SVG("triangles_elem").size("100%", "100%");
    let group = draw.group("main");
    let gradient_group = draw.group("gradient");

    draw.viewbox(0, 0, 800, 900);

    let svg_elem_group = group.svg(svg_str);

    let gradient = draw.gradient("linear", (add) => {
      add.at(0, "#899089");
      add.at(1, "#788978");
    });
    
    let svg_background = group
      .rect(1000, 1000)
      .fill(gradient)
      .id("gradient_background")
      .opacity(1.0);
    svg_background.back();
    let triangle_design = this.state.sample_triangles_design;

    this.setState({design: this.state.sample_triangles_design});

    this.props.setDesignAction(triangle_design);
  }

  initSVGWaves(design) {
    if (this.gradientRef && this.gradientRef.current) {
      this.gradientRef.current.style.background = `linear-gradient(${design.body.gradient.deg}deg, ${design.body.gradient.color1} 0%, ${design.body.gradient.color2} 100%)`;

    }

  
    this.setState({design: design});
    this.props.setDesignAction(design);

    this.drawSVGWaves();
  }

  
  startWithSVGWavesBackground(isAnimated) {
    if (isAnimated) {
      let particles_options = this.state.sample_particles_options;
      // ensure background mode is enabled
  
      this.setState({ particlesOptions: particles_options });
    }

    let design = this.state.design;

    if (isAnimated) {
      design.designType = "svgWavesAnimated";
    }
    else {
      design = this.state.sample_gradient_waves_design;
      this.gradientRef.current.style.background = `linear-gradient(${design.body.gradient.deg}deg, ${design.body.gradient.color1} 0%, ${design.body.gradient.color2} 100%)`;

    }
    this.props.setDesignAction(design);

    this.setState({design: design});

    this.drawSVGWaves();
  }

  drawSVGWaves() {
    this.state.draw = SVG("wave").size("100%", "100%");
    this.state.group = this.state.draw.group("main");
    this.state.draw.viewbox(0, 0, 1920, 150)

    let gradient = this.state.draw.gradient("linear", (add) => {
      add.at(0, "#f46");
      add.at(1, "#103");
    });

    let wave = this.state.group
    .path(
      "M0 67 C 273,183 822,-41 1920.01,106 V 359 H 0 V 67 Z"
    )
    .fill("white")
    .opacity(1.0);
  }

  
  drawTrianglesDesign(design_body) {
    let color_codes = design_body.codes;
    
    var headerMapColorRender = function (path) {
		  var random = design_body.randomColorNum;
		  var ratio = (path.x + path.y) / (path.cols + path.lines);
      var code = Math.floor(255 - (ratio * (255-random)) - Math.random()*random).toString(16);
      if (design_body.alteredColor == "red") {
        return '#' + code + color_codes[0] + color_codes[1];
      }
      else if (design_body.alteredColor == "green") {
        return '#' + color_codes[0] + code + color_codes[1];
      }
      else {
        return '#' + color_codes[0] + color_codes[1] + code;
      }
    };
    
    this.updateTrianglesBackgroundColor(design_body);
    
    var svg = new Triangulr (window.innerWidth, window.innerHeight * 1.5, 100, 50, headerMapColorRender);
    let triangles_container = document.getElementById('triangles');

    if (triangles_container.hasChildNodes()) {
      let target = triangles_container.firstChild;
      target.replaceWith(svg);
    }
    else {
      triangles_container.appendChild(svg);
    }
  }

  updateTrianglesBackgroundColor(gradient) {
    let triangles_elem = document.getElementById("triangles");
    triangles_elem.style.background = `linear-gradient(90deg, ${gradient.color1} 0%, ${gradient.color2} 100%)`;
  }

  startWithParticlesBackground() {
    let particles_options = this.state.sample_particles_options;
    // ensure background mode is enabled

    this.setState({ particlesOptions: particles_options });

    let design = this.state.design;
    design.body = particles_options;
    design.designType = "animated";
    this.props.setDesignAction(design);
    this.setState({design: design});
  }

  initSVGCanvas() {
    let svg_body_str = JSON.stringify({ svg_str: this.state.template_svg });
    let design = { body: svg_body_str, designType: "svg" };
    this.initSVG(design, "svg_illustration", "new");
  }

  captureCanvas() {
    const canvas = this.state.container.current.canvas.element;
    let img = canvas.toDataURL("image/png");
    return img;
  }

  blobToBase64 = function (blob, template_str) {
    var reader = new FileReader();
    reader.onload = function () {
      var dataUrl = reader.result;
      var base64 = dataUrl.split(",")[1];

      const templateData = {
        title: "Template1",
        body: template_str,
        image: "data:image/png;base64," + base64,
      };

      axios
        .post(
          `https://us-central1-svgbackgroundmaker.cloudfunctions.net/api/template/`,
          templateData
        )
        .then((response) => {
        })
        .catch((error) => {
          if (error) {
            this.handleError(error);
          }
        });
    };
    reader.readAsDataURL(blob);
  };

  uploadTemplate() {
    let options = this.state.container.current.options;

    const authToken = localStorage.getItem("AuthToken");

    axios.defaults.headers.common = { Authorization: `${authToken}` };

    let template_str = JSON.stringify(options);
    var app = this;
    this.state.container.current.exportImage(function (blob) {
      app.blobToBase64(blob, template_str);
    });
  }

  componentWillUnmount() {
    // remove event listener
    document.removeEventListener("keydown", this.onKeyPressed.bind(this));
  }

  onKeyPressed(e) {
    if (e.ctrlKey && e.keyCode == "C".charCodeAt(0)) {
      e.preventDefault();
      var clone = this.state.selectedElement.clone().draggable();
      this.state.copiedElement = clone;
      this.state.copiedElement.remove();
    } else if (e.ctrlKey && e.keyCode == "V".charCodeAt(0)) {
      if (this.state.copiedElement != null) {
        e.preventDefault();
        this.state.draw.add(this.state.copiedElement);
        this.addOnClickListener(this.state.copiedElement);

      } else {
        // create new clone
        var clone = this.state.selectedElement.clone().draggable();
        this.state.copiedElement = clone;
        this.addOnClickListener(clone);
      }
      // element now pasted, set to null again, so that if user presses CTRL+V numerous times/pastes numerous times,
      // we can copy the element again
      this.state.copiedElement = null;
    } else if (e.ctrlKey && e.keyCode == "X".charCodeAt(0)) {
      e.preventDefault();

      this.props.deleteSVGElementAction();
    }
  }

  getSVG() {
    let svg_str = this.state.draw.svg();

    return svg_str;
  }

  addOnClickListeners() {
    let elements = this.state.group.children();

    if (elements.length > 0) {
      elements.forEach((elem) => {
        this.addOnClickListener(elem);
      });
    }
  }

  addOnClickListener(element) {
    var app = this;
    var click = function () {
      app.deselectAllElements();

      app.state.selectedElement = this;
      if (!app.state.selectedElements.includes(this)) {
        app.state.selectedElements.push(this);
      }
      this.selectize().resize();
      app.props.setSelectedElementAction(app.state.selectedElement);
      app.props.history.push("/app/element");
    };

    element.on("mousedown", click);
  }

  deselectAllElements() {
    this.state.selectedElements.forEach((element) => {
      element.selectize(false);
    });
  }

  downloadSelectedElement() {
    if (this.state.selectedElement != null) {
      var element_svg = this.state.selectedElement.svg();
    }
  }

  fillSVGBackground(background_fill) {
    let svg_background = SVG.get("background");

    // check if background rect already exists
    if (svg_background) {
      svg_background.fill(background_fill);
    } else {
      // background rect doesn't exist, so create one.
      svg_background = this.state.group
        .rect(this.state.svgHeight, this.state.svgWidth)
        .fill(background_fill)
        .id("background")
        .opacity(1.0);
      svg_background.back();
    }
  }

  genRandomFloat(min, max) {
    return (Math.random() * (max - min) + min).toFixed(2);
  }

  genRandomRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  createRandomBokeh() {
    for (var i = 0; i < 60; i++) {
      let randomRadius = this.genRandomRange(30, 100);
      let opacity = this.genRandomFloat(0, 1);
      let l = this.genRandomRange(25, 75);
      let circle = this.state.draw
        .circle(randomRadius)
        .move(
          this.genRandomRange(0, this.state.svgWidth),
          this.genRandomRange(100, this.state.svgHeight)
        );
      circle.draggable().opacity(opacity);
      this.addOnClickListener(circle);
      // circle.fill(`hsla(${this.genRandomRange(120, 360)}, ${this.genRandomRange(0, 100)}%, ${l}%, ${this.genRandomFloat(0, 1)})`)
      circle.fill(
        `hsla(300, ${this.genRandomRange(25, 75)}%, ${l}%, ${opacity})`
      );
    }
  }

  createRandomGradientCircles() {
    var random_gradient = this.state.gradients[
      this.genRandomRange(0, this.state.gradients.length - 1)
    ];

    for (var i = 0; i < 30; i++) {
      let randomRadius = this.genRandomRange(30, 140);
      let l = this.genRandomRange(25, 75);
      let circle = this.state.draw
        .circle(randomRadius)
        .move(
          this.genRandomRange(0, this.state.svgWidth),
          this.genRandomRange(100, this.state.svgHeight)
        );
      circle.draggable();
      this.addOnClickListener(circle);

      // circle.fill(`hsla(${this.genRandomRange(120, 360)}, ${this.genRandomRange(0, 100)}%, ${l}%, ${this.genRandomFloat(0, 1)})`)

      let gradient = this.state.draw.gradient("linear", (add) => {
        add.at(0, random_gradient.color1);
        add.at(1, random_gradient.color2);
      });
      circle.fill(gradient);
      circle.opacity(this.genRandomFloat(0.4, 0.85));
    }
  }

  createRandomGradientSpheres() {
    for (var i = 0; i < 60; i++) {
      let randomRadius = this.genRandomRange(30, 100);
      let l = this.genRandomRange(25, 75);
      let circle = this.state.draw
        .circle(randomRadius)
        .move(
          this.genRandomRange(0, this.state.svgWidth),
          this.genRandomRange(100, this.state.svgHeight)
        );
      circle.draggable();
      this.addOnClickListener(circle);
      // circle.fill(`hsla(${this.genRandomRange(120, 360)}, ${this.genRandomRange(0, 100)}%, ${l}%, ${this.genRandomFloat(0, 1)})`)

      let gradient = this.state.draw.gradient("linear", (add) => {
        add.at(0, "#f5f4f3");
        add.at(1, this.props.bgColor.color2);
      });
      circle.fill(gradient);
    }
  }

  getPatternFromName(pattern_name) {
    var pattern;
    switch (pattern_name) {
      case "Escher Tiles":
        pattern = this.state.draw.pattern(200, 200, function (add) {
          add.rect(100, 100).fill("#f06");
          add.rect(100, 100).move(100, 100);
        });
        break;
      case "Stripes":
        pattern = this.state.draw.pattern(50, 50, function (add) {
          add.line(25, 0, 25, 50).stroke({ width: 25, color: "silver" });
        });
        break;

      case "Diagonal Stripes Left":
        pattern = this.state.draw.pattern(50, 50, function (add) {
          add.line(25, 0, 25, 50).stroke({ width: 25, color: "#31f" });
        });
        pattern.transform({ rotation: 125 }).transform({ rotation: 37.5 });
        break;

      case "Diagonal Stripes Right":
        pattern = this.state.draw.pattern(50, 50, function (add) {
          add.line(25, 0, 25, 50).stroke({ width: 25, color: "#f06" });
        });
        pattern.transform({ rotation: 185 }).transform({ rotation: 145.5 });

        break;
      case "Dots":
        pattern = this.state.draw.pattern(40, 40, function (add) {
          add.circle(20).fill("#f08");
        });
        break;
      case "Checkerboard":
        pattern = this.state.draw.pattern(200, 200, function (add) {
          add.rect(100, 100).fill("#f06");
          add.rect(100, 100).move(100, 100);
        });
        break;
    }

    return pattern;
  }

  showGradient() {
    if (this.state.design.designType == "gradient" || this.state.design.designType == "animated_gradient") {
      return true;
    }
    return false;
  }

  uploadImage() {

    // convert SVG to canvas
    
    const canvas_svg = document.createElement('canvas');
    const ctx = canvas_svg.getContext('2d');
    let elem = document.getElementById("triangles");
    
    let svg_elem = elem.firstChild;

    var serializer = new XMLSerializer();
    var svgString = serializer.serializeToString(svg_elem);

    let v = Canvg.fromString(ctx, svgString);
    // let v = canvg.Canvg.fromString(ctx, '<svg width="600" height="600"><text x="50" y="50">Hello World!</text></svg>');

    // // Start SVG rendering with animations and mouse handling.
    v.start();
    
    // save image 
    var storageRef = firebase.storage().ref();

    // Create a reference to 'design.jpg'
    var designImageRef = storageRef.child('design.jpg');

    // Create a reference to 'images/design.jpg'
    var ref = storageRef.child(`designs/${this.props.user.uid}/design.jpg`);

    canvas_svg.toBlob(function(blob) {
       ref.put(blob).then(function(snapshot) {
       });
    });


  }

  handleEvent = event => {
    event.preventDefault();
  };

  render() {
    return (

      <div>
        {/* <button className="mt-15" onClick={() => this.uploadImage()}>Upload Image</button> */}
        <div id="editor_canvas">

        {/* <button onClick={this.handleEvent} data-billsby-type="checkout" className="btn-sm text-white mt-20 bg-blue-600 hover:bg-blue-700 pointer">Subscribe</button> */}

          <div id="triangles" className={(this.state.design.designType == "triangles") ? "" : "hidden"}></div>
          <div id="triangles_elem" className={(this.state.design.designType == "triangles") ? "" : "hidden"}></div>
          <div id="svgwaves_elem" className={(this.state.design.designType == "svgWaves") ? "" : "hidden"}></div>

          <div id="animated_triangles" className={(this.state.design.designType == "animated_triangles") ? "" : "hidden"}></div>
          <div
            id="svg_illustration"
            className={(this.state.design.designType == "svg") ? "svg_illustration" : "hidden"}
          ></div>

           {/* <div id="svg_overlay_container" className={(this.state.design.designType == "animated" || this.state.design.designType == "svg_overlay"
          || this.state.design.designType == "gradient")
           ? "" : "nodisplay"}> */}

              {/* <div
                id="svg_overlay_illustration"
                className={( this.state.design.designType == "animated" || this.state.design.designType == "svg_overlay"
                || this.state.design.designType == "gradient") ? "svg_illustration" : "hidden"}
              ></div> */}


                {/* <div id="gradient" ref={this.gradientRef} className={this.showGradient() ? "" : "hidden"}/> */}


          {/* </div>  */}

          <div className="wave_cont">
          <div id="gradient" ref={this.gradientRef} className={(this.state.design.designType == "gradient" || this.state.design.designType == "animated_gradient"
          || this.state.design.designType == "svgWaves" || this.state.design.designType == "radialGradient") ? "" : "hidden"}/> 
          <Particles
                          id="particles"
                          width="70vw"
                          height="100vh"
                          init={this.particlesInit}
                          options={this.state.particlesOptions}
                          className={(this.state.design.designType == "animated" || this.state.design.designType == "svgWavesAnimated") ? "" : "hidden"}
                          container={this.state.container}
                          
                        />
          <div id="wave" className={(this.state.design.designType == "svgWaves" || this.state.design.designType == "svgWavesAnimated") ? "wave" : "hidden"}>

              {/* <svg width="100%" fill="none" version="1.1" viewBox="0 0 500 150"
              xmlns="http://www.w3.org/2000/svg">
                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" stop-color="#00B4DB" />
                  <stop offset="100%" stop-color="#224488" />
                </linearGradient>
                <path 
                  fill="url(#gradient)" 
                  d="
                    M0 67
                    C 273,183
                      822,-41
                      1920.01,106 
                    
                    V 359 
                    H 0 
                    V 67
                    Z">
                </path>
              </svg> */}
          </div>

          </div>

        </div>
        {/* <button onClick={() => this.uploadTemplate()} className="upload_template">Upload Template</button> */}
        {/* <button
          onClick={() => this.uploadTemplate()}
          className="upload_template"
        >
          Upload Template
        </button> */}


      </div>
    );
  }


  updateParticleBackgroundColor(container, particle_options, designType) {


    const options = container.current.options;

    options.background.image = `linear-gradient(${this.props.svgGradientBackgroundColor.deg}deg, ${this.props.svgGradientBackgroundColor.color1} 0%, ${this.props.svgGradientBackgroundColor.color2} 100%)`;
    let design = this.state.design;
    particle_options.background.image = `linear-gradient(${this.props.svgGradientBackgroundColor.deg}deg, ${this.props.svgGradientBackgroundColor.color1} 0%, ${this.props.svgGradientBackgroundColor.color2} 100%)`;
    design.body = particle_options;
    options.backgroundMode.enable = true;
    options.backgroundMode.zIndex = -1;
    container.current.refresh();
    if (designType == "animated") {
      this.setState({particlesOptions: particle_options});
    }

  }

  componentDidUpdate(prevProps, prevState, snapshot) {

    if (this.props.selectedElement == null) {
    }

    // if (
    //   prevProps.backgroundColor !== this.props.backgroundColor &&
    //   this.state.selectedElement != null
    // ) {
    //   console.log("updating background color");
    //   this.state.selectedElement.fill(this.props.backgroundColor);
    // }

    if (prevProps.backgroundPatternName !== this.props.backgroundPatternName) {
      let pattern = this.getPatternFromName(this.props.backgroundPatternName);
      this.fillSVGBackground(pattern);
    }

    if (
      prevProps.bgColor !== this.props.bgColor &&
      this.state.selectedElement != null
    ) {
      this.state.gradient = this.state.draw.gradient("linear", (add) => {
        add.at(0, this.props.bgColor.color1);
        add.at(1, this.props.bgColor.color2);
      });
      this.props.selectedElement.fill(this.state.gradient);
      this.deselectAllElements();
    }

    if (prevProps.element !== this.props.element) {
      if (this.state.draw == null) {
        // this.initSVG(this.state.design, "svg_overlay_illustration");
      }
      if (this.props.element != null) {
        this.deselectAllElements();
        // var elem;
        // switch(this.props.element) {
        //   case "blob":
        //     elem = this.state.draw.path('M56.5,-22.4C63.4,2.6,52.2,29.5,32.7,43.2C13.3,56.8,-14.3,57.3,-31,44.7C-47.7,32,-53.5,6.4,-46.5,-18.9C-39.5,-44.2,-19.8,-69.1,2.5,-69.9C24.9,-70.8,49.7,-47.5,56.5,-22.4Z')
        //     .move(this.state.svgWidth / 4, this.state.svgHeight / 4).draggable();
        //     break;
        //   case "circle":
        //     elem = this.state.draw.circle(90).move(this.state.svgWidth / 3, this.state.svgHeight / 3);
        //     break;
        //   case "rect":
        //       elem =
        //       break;
        //   case "ellipse":
        //     elem = this.state.draw.ellipse(200, 100).move(this.state.svgWidth / 4, this.state.svgHeight / 4);
        //     break;
        //   case "star":
        //     elem = this.state.draw.polygon('0,0 100,50 50,100').fill('none').stroke({ width: 1 });
        //     break;
        // }
        this.state.group.add(this.props.element);
        this.state.selectedElement = this.props.element;

        this.state.selectedElement.draggable().selectize().resize();
        this.state.selectedElement.opacity(1.0);
        this.state.selectedElements.push(this.props.element);
        // this.state.selectedElements.push(this.state.selectedElement);
        // TODO route to /app/element
        this.addOnClickListener(this.state.selectedElement);

        this.props.setElementAction(null);
      }
      this.props.setSelectedElementAction(this.state.selectedElement);
      this.props.setSelectedElementsAction(this.state.selectedElements);
    }

    if (prevProps.animatedBackground != this.props.animatedBackground) {
      if (this.props.animatedBackground.designType == "animated") {
        this.updateAnimatedBackgroundFromOnlineDesign(this.props.animatedBackground);
      }
      else if (this.props.animatedBackground.designType == "gradient" || this.props.animatedBackground.designType == "animated_gradient") {
        this.initGradient(this.props.animatedBackground);
      }
      else if (this.props.animatedBackground.designType == "radialGradient") {
        this.initRadialGradient(this.props.animatedBackground)
      }
      
    }

    if (prevProps.svgBackgroundColor !== this.props.svgBackgroundColor) {
      this.props.setSelectedElementAction(null);

      if (this.state.design.designType == "svg") {
        this.fillSVGBackground(this.props.svgBackgroundColor);
      }
      else if (this.state.design.designType == "animated") {

          const options = this.state.container.current.options;

          let design = this.state.design;
          design.body = this.state.particlesOptions;
          options.background.color.value = this.props.svgBackgroundColor;

          this.state.container.current.refresh();
      }

    }

    if (prevProps.templates != this.props.templates) {
      this.setState({ templates: this.props.templates });
    }

    if (prevProps.opacity !== this.props.opacity) {

      if (this.state.design.designType == "svg") {
        let svg_background = SVG.get("background");
  
        // check if background rect already exists
        if (svg_background != null) {  
          svg_background.opacity(this.props.opacity);    
        }
      } 
      else if (this.state.design.designType == "animated") {

        const options = this.state.container.current.options;

        let design = this.state.design;
        design.body = options;
        options.background.opacity = this.props.opacity;

        this.state.container.current.refresh();
      }
    }

    if (prevProps.svgBackgroundTemplate !== this.props.svgBackgroundTemplate) {

      this.updateSVGBackgroundTemplate(this.props.svgBackgroundTemplate);
    }

    if (
      prevProps.svgGradientBackgroundColor !==
      this.props.svgGradientBackgroundColor
    ) {

      if (this.state.design.designType == "svg") {
        let gradient = this.state.draw.gradient("linear", (add) => {
          add.at(0, this.props.svgGradientBackgroundColor.color1);
          add.at(1, this.props.svgGradientBackgroundColor.color2);
        });
        this.fillSVGBackground(gradient);
      } 

      
      else if (this.state.design.designType == "gradient" || this.state.design.designType == "animated_gradient") {
        // is gradient design

        this.gradientRef.current.style.background = `linear-gradient(${this.props.svgGradientBackgroundColor.deg}deg, ${this.props.svgGradientBackgroundColor.color1} 0%, ${this.props.svgGradientBackgroundColor.color2} 100%)`;
        let design = this.state.design;
        design.body.color1 = this.props.svgGradientBackgroundColor.color1;
        design.body.color2 = this.props.svgGradientBackgroundColor.color2;
        design.body.deg = this.props.svgGradientBackgroundColor.deg;

        this.setState({design: design});

        if (this.state.design.designType == "animated_gradient") {
          this.gradientRef.current.style.backgroundSize = "400% 400%";
          this.gradientRef.current.style.animation = "gradient 25s ease infinite";
           
        }
      }

      else if (this.state.design.designType == "radialGradient") {
        // is gradient design

        this.gradientRef.current.style.background = `linear-gradient(45deg, ${this.props.svgGradientBackgroundColor.color1} 0%, hsla(352, 96%, 45%, 0) 70%),
        linear-gradient(135deg, ${this.props.svgGradientBackgroundColor.color2} 10%, hsla(253, 95%, 42%, 0) 80%),
        linear-gradient(225deg, ${this.props.svgGradientBackgroundColor.color3} 10%, hsla(179, 91%, 45%, 0) 80%),
        linear-gradient(315deg, ${this.props.svgGradientBackgroundColor.color4} 100%, hsla(119, 96%, 49%, 0) 70%)`;
        let design = this.state.design;
        design.body.color1 = this.props.svgGradientBackgroundColor.color1;
        design.body.color2 = this.props.svgGradientBackgroundColor.color2;
        design.body.color3 = this.props.svgGradientBackgroundColor.color3;
        design.body.color4 = this.props.svgGradientBackgroundColor.color4;

        this.setState({design: design});
      }

      else if (this.state.design.designType == "svgWaves") {
        this.gradientRef.current.style.background = `linear-gradient(${this.props.svgGradientBackgroundColor.deg}deg, ${this.props.svgGradientBackgroundColor.color1} 0%, ${this.props.svgGradientBackgroundColor.color2} 100%)`;
        let design = this.state.design;

        design.body.gradient.color1 = this.props.svgGradientBackgroundColor.color1;
        design.body.gradient.color2 = this.props.svgGradientBackgroundColor.color2;
        design.body.gradient.deg = this.props.svgGradientBackgroundColor.deg;

        this.setState({design: design});
      }

      else if (this.state.design.designType == "animated") {
        this.updateParticleBackgroundColor(this.state.container, this.state.particlesOptions, "animated")
      }

      else if (this.state.design.designType == "svgWavesAnimated") {
        this.updateParticleBackgroundColor(this.state.container, this.state.particlesOptions, "svgWavesAnimated")
      }

      else if (this.state.design.designType == "svg_overlay") {
        this.updateParticleBackgroundColor(this.state.container, this.state.particlesOptions, "svg_overlay")
      }

      else if (this.state.design.designType == "triangles") {
        let design = this.state.design;
        design.body = this.props.svgGradientBackgroundColor;
      
        this.drawTrianglesDesign(design.body);
      }

    }

    if (
      prevProps.downloadSVGElementAction != this.props.downloadSVGElementAction
    ) {
    }
  }
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Canvas));
